import { render, staticRenderFns } from "./VinInformationSidebar.vue?vue&type=template&id=77ec7fea&"
import script from "./VinInformationSidebar.vue?vue&type=script&lang=js&"
export * from "./VinInformationSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports